import { render } from "./AboutUsContent.vue?vue&type=template&id=2aa637e0"
import script from "./AboutUsContent.vue?vue&type=script&lang=js"
export * from "./AboutUsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__